"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TrainModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _Train = _interopRequireDefault(require("@material-ui/icons/Train"));
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));
var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));
var _Header = _interopRequireDefault(require("../components/Header"));
var _Item = _interopRequireDefault(require("../components/Item"));
var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));
var TrainModal = exports.TrainModal = function TrainModal(_ref) {
  var logo = _ref.logo,
    title = _ref.title,
    departure = _ref.departure,
    arrival = _ref.arrival,
    date = _ref.date,
    vendor = _ref.vendor,
    reservationCode = _ref.reservationCode,
    aside = _ref.aside;
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_Train["default"], null),
    content: vendor
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], null),
    content: date
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], null),
    content: reservationCode
  }];
  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    from: {
      label: departure.location,
      text: departure.code,
      subText: departure.time
    },
    to: {
      label: arrival.location,
      text: arrival.code,
      subText: arrival.time
    }
  }), items.map(function (_ref2, index) {
    var icon = _ref2.icon,
      content = _ref2.content;
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: index,
      icon: icon
    }, content);
  }));
};
var _default = exports["default"] = TrainModal;
//# sourceMappingURL=Train.js.map